import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetPromotionsBySearch(club, url) {
  var url = "/reservation/get_promotion_by_search/" + club + url;

  return FetchGetDataWithAuthNEW(url);
}
